import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = [];
  static values = {
    formElementId: String,
    isAuthenticated: Boolean,
  };

  connect() {
    if (this.isAuthenticatedValue) return;
    this.check();
  }

  async check() {
    const password = window.prompt('비밀번호를 입력해주세요.');
    if (password === null || password === '') {
      window.alert('비밀번호를 입력해주세요.');
      location.reload();
      return;
    }
    callApi(`/api/siteconfigs/auth`, 'POST', { password })
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.alert(err.msg);
        location.reload();
      });
  }

  async edit() {
    var form = document.getElementById(this.formElementIdValue);
    var formData = new FormData(form);

    const body = [];
    for (var [key, value] of formData.entries()) {
      if (key === '_csrf') {
        continue;
      }
      const config = {};
      config.name = key;
      config.value = value;
      body.push(config);
    }

    this.callApi(
      '/api/siteconfigs',
      body,
      'PUT',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  callApi(url, body, method, successCallback, failedCallback) {
    fetch(_spring['context_path'] + url, {
      method,
      credentials: 'include',
      headers: Object.assign({}, _csrf, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        if (res.ok) {
          if (Number(res.headers.get('content-length')) === 0) {
            return;
          } else {
            return res.json();
          }
        }
        return Promise.reject(res.json());
      })
      .then((res) => {
        if (successCallback !== undefined && successCallback !== null) {
          successCallback(res);
        }
      })
      .catch((error) => {
        if (failedCallback !== undefined && failedCallback !== null) {
          error.then((err) => {
            failedCallback(err);
          });
        }
      });
  }
}
